import { apeChain as viemApeChain } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const apeChain = {
  displayName: 'ApeChain',
  runtime: 'evm',
  viemChain: viemApeChain,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'ape' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
